import { useFormikContext } from "formik"
import { useDEFormContext } from "../context/DEFormContext"


const StatusSection = () => {
    const formik = useFormikContext()
    const { decidedPendingOptions } = useDEFormContext()

    return (
        <>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Status <span style={{ color: 'red' }}>*</span>
                </label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        name="deStatus"
                        value={formik.values.deStatus}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    >
                        <option value="">Select Status</option>
                        {decidedPendingOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    {formik.touched.deStatus && formik.errors.deStatus && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.deStatus}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default StatusSection